import React, { useEffect, useState } from "react";
import Form from 'react-bootstrap/Form';

export interface QuantityProps {
    onChangeCallback: (value: number | undefined) => void;
    id?: string;
    value?: string | number | undefined;
    label?: string;
    disabled?: boolean;
}
  
export const EditQuantity = ( {
  id = 'QuantityEdit', 
  value = '', 
  label = 'Quantité', 
  disabled = false, 
  onChangeCallback}: QuantityProps  ) => {
  
    const [quantity, setQuantity] = useState<string>(value?.toString() || '');

      useEffect(() => {
        if (Number.isNaN(Number(value))) {
          setQuantity('');
        } else {
          setQuantity(value?.toString() || '');
        }
    
      }, [value]);

      const onHandleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        const newValue = e.target.value;

        if (newValue.trim() === '' || newValue.trim() === '-' || newValue.trim() === '+' || newValue.trim() === '.') {
          setQuantity(newValue);
          onChangeCallback(undefined);
          return;
        }

        if (!Number.isNaN(Number(newValue))) {
          onChangeCallback(parseFloat(newValue));
          setQuantity(newValue);
        }

        
      }

       return (
          <Form.Floating className="mb-1">
              <Form.Control
              key={id}
              id={id}
              type="text"
              placeholder="" 
              value={quantity}
              onChange={onHandleChange}
              disabled = {disabled} 
              />
              <label htmlFor={id}>{label}</label>
    
        </Form.Floating>
      )
    }
  